import { jsx as t } from "react/jsx-runtime";
function r(e) {
  return /* @__PURE__ */ t(
    "svg",
    {
      id: "Layer",
      height: "512",
      viewBox: "0 0 24 24",
      width: "512",
      xmlns: "http://www.w3.org/2000/svg",
      ...e,
      children: /* @__PURE__ */ t(
        "path",
        {
          id: "test-tube-alt",
          d: "m21.53 9.47-7-7a.75.75 0 0 0 -1.06 1.06l.47.47-10.435 10.435a4.285 4.285 0 0 0 6.06 6.06l10.435-10.434.47.47a.75.75 0 1 0 1.06-1.061zm-6.59 3.53h-7.879l7.939-7.939 3.94 3.939z"
        }
      )
    }
  );
}
export {
  r as TestTubeIcon
};
